<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Member Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editPerson">Edit Member</button>
                </div>
            </div>
            <div class="table-responsive" v-if="person">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{person.staffId}}</td>
                    </tr>
                    <tr>
                        <th>Name</th>
                        <td>{{person.memberFirstName}}</td>
                    </tr>
                    <tr>
                        <th>Image URL</th>
                        <td><a :href="person.memberImageUrl" :title="person.memberFirstName">{{person.memberImageUrl}}</a> </td>
                    </tr>
                  <tr>
                    <th>Image</th>
                    <td><img class="table-thumbnail" :title="person.memberFirstName":src="person.memberImageUrl" /></td>
                  </tr>
                  <tr>
                    <th>Biography</th>
                    <td><p>{{person.biography}}</p></td>
                  </tr>
                  <tr>
                    <th>Display Order</th>
                    <td>{{person.displayOrder}}</td>
                  </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="person.active == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewPerson',
        components: {
            LTable,
        },
        created (){
            console.log('inside view person')
        this.$store.dispatch('GETSELECTEDPERSON', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedPerson)
            this.person = this.selectedPerson;
        })
    },
    data () {
        return {
          person: {}
        }
    },
    methods: {
        editPerson(){
            this.$router.push({ name: 'EditPerson', params: { id: this.person.staffId}})
        },
    },
    computed: {...mapGetters([
        'selectedPerson'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Persons/PersonDetails.vue